import type { ReactNode } from 'react';

export const symbol_sell_cloud: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M436-480ZM219-80h136q12 0 21-8.63 9-8.62 9-21.37 0-12-9-21t-21-9H219v-465l217-215 217 217v127q0 12 8.63 20.5 8.62 8.5 21.37 8.5 12 0 21-8.63 9-8.62 9-21.37v-125q0-11-5.5-23T694-645L477-862q-9.07-9-20.04-13.5Q446-880 435-880q-12 0-23 4.5T392-862L176-646q-9 9-13 20.5t-4 22.5v463q0 25 17.5 42.5T219-80Zm217-540q-22 0-37-15t-15-37q0-21 14.79-36 14.8-15 37.21-15 22 0 37 15t15 36q0 22-15 37t-37 15Zm84 540q-51 0-85.5-34.5T400-200q0-48 33-82.5t81-37.5q17-37 50.5-58.5t75.21-21.5q49 0 89.15 26.5Q769-347 778-300h2q43 0 71.5 32.5T880-190q0 45-28.5 77.5T780-80H520Zm0-60h250q20 0 35-14.5t15-35.97q0-19.81-15-34.67Q790-240 770-240h-40v-10q0-37-26.5-63.5T640-340q-28 0-50 15.5T558-283l-8 23h-30q-25.5 0-42.75 17.35t-17.25 43Q460-174 477.25-157T520-140Zm120 0Z"
		/>
	</svg>
);
